import React, { Component } from 'react';
import axios from 'axios';
import Moment from 'react-moment';
import 'moment/locale/pt';
import {
    Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter,
} from 'material-ui/Table';
import Snackbar from 'material-ui/Snackbar';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import Chip from 'material-ui/Chip';
import LinearProgress from 'material-ui/LinearProgress';
import { red700 } from 'material-ui/styles/colors';

import { GetJobs, PauseJob, ResumeJob, RunJob } from '../../../http/SchedulerService';
import { JobMatch, CronStyleScheduleTime } from '../../../helpers/JobHelpers'

import SearchBar from './SearchBar';
import JobViewDrawer from '../job/JobViewDrawer';
import ItemsToolbar from './ItemsToolbar';

import ConfirmUndoChangesDialog from '../job/ConfirmUndoChangesDialog';

Moment.globalLocale = 'pt';

class SchedulerList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            requesting: true,
            snackbarOpen: false,
            snackbarMsg: "",
            selectedRows: [],
            tableData: null,
            selectedJob: null,
            filterJobs: "",
            onlyEnabledJobs: false,
            undoChangesDialogOpen: false,
            waitingUndoChange: null,
            dirtyForm: false
        };

        this.handleRunAll = this.handleRunAll.bind(this);
        this.onCloseDrawer = this.onCloseDrawer.bind(this);
        this.handleUndoChangesDialogClose = this.handleUndoChangesDialogClose.bind(this);
        this.handleUndoChangesDialogConfirm = this.handleUndoChangesDialogConfirm.bind(this);
    }

    allJobs = null;

    fetchJobs = () => {
        if (!this.state.requesting) {
            this.setState({ requesting: true });
        }

        GetJobs()
            .then(response => {
                this.allJobs = response.data;;
                this.setState({ requesting: false, selectedRows: [] });
                this.filterJobs(this.state.filterJobs, this.state.onlyEnabledJobs);
            })
            .catch(error => {
                this.showSnackbarMessage(`Erro ao carregar tarefas!`);
                this.setState({ requesting: false });
            });
    };

    handleUndoChangesDialogClose = () => {
        this.setState({ undoChangesDialogOpen: false });
    };

    handleUndoChangesDialogConfirm = () => {
        this.setState({ undoChangesDialogOpen: false, dirtyForm: false, selectedJob: this.state.waitingUndoChange });
    };

    handleFilterJobs = (event) => {
        this.filterJobs(event.target.value);
    };

    filterJobs = (text, onlyEnabled) => {
        onlyEnabled = onlyEnabled !== undefined ? onlyEnabled : this.state.onlyEnabledJobs;

        let jobs = this.allJobs.filter(job => {
            if (onlyEnabled && !job.next_run_time) {
                return null;
            }
            return JobMatch(job, text) ? job : null;
        });

        jobs.sort(function (a, b) {
            return a.name.localeCompare(b.name);
        });

        this.setState({ tableData: jobs, filterJobs: text });
    };

    handleOnlyEnabled = (show) => {
        this.setState({ onlyEnabledJobs: show });
        this.filterJobs(this.state.filterJobs, show);
    };

    activeJobs = (jobs) => {
        return (jobs && jobs.length) ? jobs.filter(t => {
            return t.next_run_time
        }) : [];
    };

    onRefreshClick = (e) => {
        this.fetchJobs();
    };

    showSnackbarMessage = (message) => {
        this.setState({ snackbarOpen: true, snackbarMsg: message });
    };

    handleSnackbarClose = () => {
        this.setState({ snackbarOpen: false });
    };

    handlePause = () => {
        if (!this.state.selectedRows.length) return;

        this.setState({ requesting: true });

        let reqs = [];

        const selectedRows = this.state.selectedRows === "all" ?
            [...Array(this.state.tableData.length).keys()] :
            this.state.selectedRows;

        selectedRows
            .filter(i => this.state.tableData[i].next_run_time)
            .map(i => reqs.push(PauseJob(this.state.tableData[i])));

        axios.all(reqs).then((result) => {
            this.fetchJobs();
            this.setState({ requesting: false, selectedRows: [] });
            this.showSnackbarMessage(`${result.length} tarefas desativadas`);
        });
    };

    handleResume = () => {
        if (!this.state.selectedRows.length) return;

        this.setState({ requesting: true });

        let reqs = [];

        const selectedRows = this.state.selectedRows === "all" ?
            [...Array(this.state.tableData.length).keys()] :
            this.state.selectedRows;

        selectedRows
            .filter(i => !this.state.tableData[i].next_run_time)
            .map(i => reqs.push(ResumeJob(this.state.tableData[i])));

        axios.all(reqs).then((result) => {
            this.fetchJobs();
            this.setState({ requesting: false, selectedRows: [] });
            this.showSnackbarMessage(`${result.length} tarefas ativadas`);
        });
    };

    handleRunAll = () => {
        if (!this.state.selectedRows.length) return;

        this.setState({ requesting: true });

        let reqs = [];

        const selectedRows = this.state.selectedRows === "all" ?
            [...Array(this.state.tableData.length).keys()] :
            this.state.selectedRows;

        selectedRows
            .map(i => reqs.push(RunJob(this.state.tableData[i])));

        axios.all(reqs).then((result) => {
            this.fetchJobs();
            this.setState({ requesting: false, selectedRows: [] });
            this.showSnackbarMessage(`${result.length} tarefas executadas`);
        })
            .catch((error) => {
                this.setState({ requesting: false, selectedRows: [] });
                this.showSnackbarMessage("" + error);
            });
    };

    onRowSelection = (selectedRows) => {
        if (["all", "none"].indexOf(selectedRows) >= 0) {
            this.setState({ selectedRows: (selectedRows !== "none" ? selectedRows : []) });
        }
    };

    handleCellClick = (rowNumber, columnNumber, evt) => {
        if (columnNumber >= 0) {
            const job = this.state.tableData[rowNumber];

            if (this.state.dirtyForm) {
                this.setState({ undoChangesDialogOpen: true, waitingUndoChange: job });
            } else {
                this.setState({ selectedJob: job, dirtyForm: false });
            }
        }
        else {
            let selectedRows = this.state.selectedRows;

            if (selectedRows === "all")
                selectedRows = this.state.tableData.map((j, i) => i).filter(i => i !== rowNumber);

            if (selectedRows.indexOf(rowNumber) >= 0)
                selectedRows = selectedRows.filter(r => r !== rowNumber);

            else
                selectedRows.push(rowNumber);

            this.setState({ selectedRows: selectedRows, dirtyForm: false });
        }
    }

    isSelected = id => this.state.selectedRows.indexOf(id) !== -1;

    onNewClick = job => event => {
        this.setState({ selectedJob: job, dirtyForm: false});
    }

    onCloseDrawer = event => {
        if (this.state.dirtyForm) {
            this.setState({ undoChangesDialogOpen: true, waitingUndoChange: null });
        } else {
            this.setState({ selectedJob: null });
        }
    }

    onJobSubmit = (job, args = {}) => {
        this.allJobs = this.allJobs.filter(old => old.id !== job.id);

        if (!args.removed) {
            this.allJobs.push(job);
            this.setState({ selectedJob: job, dirtyForm: false });
        }

        else this.setState({ selectedJob: null, dirtyForm: false });

        this.filterJobs("");
    }

    handleDirtyForm = (dirty) => {
        this.setState({dirtyForm: dirty});
    }

    render() {
        if (!this.allJobs) {
            this.fetchJobs();
        }

        const { selectedJob, requesting, dirtyForm, tableData } = this.state;
        const hasSelected = Boolean(this.state.selectedRows.length);
        const allRowsSelected = Boolean(this.state.selectedRows === "all");
        const activeJobs = this.activeJobs(tableData).length;

        return (
            <div style={{ marginTop: 20 }}>
                <div style={{ height: 4 }}>{requesting && <LinearProgress mode="indeterminate" />}</div>
                
                <ConfirmUndoChangesDialog
                        open={this.state.undoChangesDialogOpen}
                        handleConfirm={this.handleUndoChangesDialogConfirm}
                        handleClose={this.handleUndoChangesDialogClose} />

                <JobViewDrawer
                    drawerOpen={Boolean(selectedJob)}
                    job={selectedJob}
                    dirtyForm={dirtyForm}
                    handleDirtyForm={this.handleDirtyForm}
                    onJobSubmit={this.onJobSubmit}
                    onCloseDrawer={this.onCloseDrawer}
                    showSnackbarMessage={this.showSnackbarMessage} />

                <Table
                    fixedHeader={true}
                    fixedFooter={true}
                    selectable={!this.state.requesting}
                    multiSelectable={!this.state.requesting}
                    onRowSelection={this.onRowSelection}
                    onCellClick={this.handleCellClick}
                    allRowsSelected={allRowsSelected}
                >
                    <TableHeader
                        displaySelectAll={true}
                        adjustForCheckbox={true}
                        enableSelectAll={true}
                    >
                        <TableRow>
                            <TableHeaderColumn colSpan="4" style={{ textAlign: 'left' }}>
                                <SearchBar
                                    onTextChange={this.handleFilterJobs}
                                    onlyEnabled={this.handleOnlyEnabled}
                                    onRefreshClick={this.onRefreshClick} />
                            </TableHeaderColumn>
                        </TableRow>
                        <TableRow>
                            {!hasSelected &&
                                <TableHeaderColumn style={{ textAlign: 'left' }}>
                                    Tarefa
                                </TableHeaderColumn>
                            }
                            {!hasSelected &&
                                <TableHeaderColumn style={{ textAlign: 'left' }}>
                                    Cron
                                </TableHeaderColumn>
                            }
                            {!hasSelected &&
                                <TableHeaderColumn style={{ textAlign: 'right' }}>
                                    Última execução
                                </TableHeaderColumn>
                            }
                            {!hasSelected &&
                                <TableHeaderColumn style={{ textAlign: 'right' }}>
                                    Proxima execução
                                </TableHeaderColumn>
                            }
                            {hasSelected &&
                                <TableHeaderColumn colSpan="4" style={{ textAlign: 'left' }}>
                                    {tableData &&
                                        <ItemsToolbar
                                            requesting={requesting}
                                            hasSelected={hasSelected}
                                            selectedLength={this.state.selectedRows.length}
                                            allRowsSelected={allRowsSelected}
                                            activeJobs={activeJobs}
                                            tableDataLength={tableData.length}
                                            handlePause={this.handlePause}
                                            handleResume={this.handleResume}
                                            handleRun={this.handleRunAll} />
                                    }
                                </TableHeaderColumn>
                            }
                        </TableRow>
                    </TableHeader>
                    <TableBody
                        displayRowCheckbox={true}
                        deselectOnClickaway={false}
                        showRowHover={true}
                        stripedRows={false}
                    >
                        {tableData && tableData.map((job, index) => (
                            <TableRow key={job.id} selected={this.isSelected(index)}>
                                <TableRowColumn>{job.name}</TableRowColumn>
                                <TableRowColumn>
                                    <div style={{ flexGrow: 1, alignSelf: 'center' }}>
                                        {job.trigger === 'cron' && <span>cron {CronStyleScheduleTime(job)}</span>}
                                        {job.trigger !== 'cron' && <span>{job.trigger}</span>}
                                    </div>
                                </TableRowColumn>
                                <TableRowColumn>
                                    <div style={{ display: 'flex' }}>
                                        <div style={{ flexGrow: 1 }}></div>
                                        
                                        {job.last_run_time && <Moment format="LLL">{job.last_run_time}</Moment>}

                                        {!job.last_run_time && <span> -- </span>}
                                    </div>
                                </TableRowColumn>
                                <TableRowColumn>
                                    <div style={{ display: 'flex' }}>
                                        <div style={{ flexGrow: 1 }}></div>
                                        
                                        {job.next_run_time && <Moment format="LLL">{job.next_run_time}</Moment>}

                                        {!job.next_run_time && <Chip backgroundColor={red700} labelColor="white">Inativo</Chip>}
                                    </div>
                                </TableRowColumn>
                            </TableRow>
                        ))}
                    </TableBody>
                    {tableData &&
                        <TableFooter>
                            <TableRow>
                                <TableRowColumn colSpan="4" style={{ textAlign: 'center'}}>
                                    <div style={{ color: 'gray', fontWeight: 'bold' }}>
                                        {`${activeJobs} tarefas ativas`}
                                        {activeJobs !== tableData.length && `, ${tableData.length} no total`}
                                    </div>
                                </TableRowColumn>
                            </TableRow>
                        </TableFooter>
                    }
                </Table>

                <FloatingActionButton
                    onClick={this.onNewClick('new')}
                    style={{
                        position: 'fixed',
                        bottom: 16,
                        right: 16
                    }}>
                    <ContentAdd />
                </FloatingActionButton>

                <Snackbar
                    open={this.state.snackbarOpen}
                    message={this.state.snackbarMsg}
                    autoHideDuration={3000}
                    action="FECHAR"
                    onActionClick={this.handleSnackbarClose}
                    onRequestClose={this.handleSnackbarClose}
                />
            </div>
        );
    }
}

export default SchedulerList;


// WEBPACK FOOTER //
// ./src/components/view/scheduler/list/SchedulerList.js